<template>
  <div class="report">
    <div class="img-warpper" v-for="(item, index) in reports" :key="index">
      <img
        :src="host + item.reportUrl"
        :class="[item.isPad === '1' ? 'pad' : hasPad ? 'no-pad' : 'pad']"
      />
    </div>
  </div>
</template>

<script>
import util from '@/utils';

import { reportApi } from "@/services/api";
export default {
  data() {
    return {
      reports: [],
      host: process.env.VUE_APP_BASE_API,
      hasPad: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const params = {
        reportId: this.$route.query.id,
        pageNum: 1,
        pageSize: 99,
      };
      const res = await reportApi(params);
      if (res?.code === 200) {
        this.sortHandle(res.rows);
        const has = res.rows.find((item) => item.isPad === "1");
        if (has) {
          this.hasPad = true;
        } else {
          this.hasPad = false;
        }
      }
    },
    sortHandle(list) {
      list.sort((item1, item2) => {
        return item1.orderNum - item2.orderNum;
      });
      this.reports = list;
    },
  },
};
</script>

<style lang="scss" scoped>
.report {
  height: 100%;
  font-size: 16px;
  background: #fff;
  .img-warpper {
    width: 100%;
    padding: 8px 20px;
    img {
      width: 100%;
      border: 1px dashed;
    }
    .pad {
      width: 100%;
    }
    .no-pad {
      width: 100%;
    }
  }
}
</style>
